import '../../App.css';
import React, { useContext } from "react";
import { IoIosWarning } from "react-icons/io";
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalExcluirTipoServico({currentPage}) {

    const { setModalExcluirTipoServico, ExcluirTipoServico, TipoServicoAtualKey } = useContext(ServicoContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    return (
        <div className="modal-novo">
            <div className="modal-interno-delete">
                <div className="modal-content-delete">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '20px', padding: '16px' }} className='border-bottom'>
                        <div>
                            <IoIosWarning style={{ color: '#FACC15', marginRight: '5px' }} /> Excluir tipo de serviço
                        </div>
                        <button className='btn-fechar' onClick={() => setModalExcluirTipoServico(false)}>
                            <FaTimes />
                        </button>
                    </div>
                    <div style={{ padding: '16px' }} className='border-bottom'>
                        Tem certeza que deseja excluir esse tipo de serviço?
                    </div>
                    <div className="content-buttons">
                        <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalExcluirTipoServico(false)}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={() => ExcluirTipoServico(TipoServicoAtualKey, currentPage)}>Excluir</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalExcluirTipoServico